import { autoserialize } from 'cerialize';

export class PartnerMeta implements IPartnerMeta {
  @autoserialize autoAcceptEnabled: boolean;
  @autoserialize etaTrackingEnabled: boolean;
  @autoserialize sponsorshipUI: boolean;

  constructor(payload?: IPartnerMeta | null) {
    this.autoAcceptEnabled = !!payload?.autoAcceptEnabled;
    this.etaTrackingEnabled = !!payload?.etaTrackingEnabled;
    this.sponsorshipUI = !!payload?.sponsorshipUI;
  }
}

export interface IPartnerMeta {
  autoAcceptEnabled?: boolean;
  etaTrackingEnabled?: boolean;
  sponsorshipUI?: boolean;
}
